let $html = document.querySelector('html');

let tracker = null;

function assertGa() {
    if (typeof gtag === 'undefined' || typeof ga === 'undefined' || typeof ga.getAll !== 'function') {
        throw 'Could not find gtag|ga';
    }

    if (ga.getAll().length === 0) {
        throw 'Located analytics, but could not reconcile any trackers';
    }
}

function getPageContext() {
    let classes = $html.classList, context = [];
    for (let c of classes) {
        if (c === 'js') continue;
        if (/^fontawesome/.test(c)) continue;
        context.push(c);
    }

    if (context.length === 0) {
        context.push('unknown');
    }

    return context.join('-');
}

function getFriendlyTypeName(type) {
    switch (type) {
        case 'a':
            return 'link';
    }
    return type;
}

function guessContext(event) {
    const $el = event.srcElement,
        eventType = event.type
    ;

    let $form = $el.closest('form');
    let $link = $el.tagName === 'A' ? $el : $el.closest('a');

    let context = [];

    context.push(getFriendlyTypeName($el.tagName.toLowerCase()));
    context.push(eventType);

    const pageContext = getPageContext();
    if (pageContext) {
        context.push('in');
        context.push(pageContext);
    }

    if ($form) {
        context.push('in');

        if ($form.classList.length > 0) {
            for (let c of $form.classList) {
                context.push(c);
            }
        }

        context.push('form');
    }

    if ($link) {
        let href = $link.getAttribute('href');
        context.push('to');
        if (/^http/.test(href)) {
            href = href.replace(/https?:\/\//, '');
            href = href.replace(/\/.*/g, '');
        }
        context.push(href);
    }

    if ($form) {
        context.push('to');
        let action = $form.getAttribute('action');
        if (/^http/.test(action)) {
            action = action.replace(/https?:\/\//, '');
            action = action.replace(/\/.*/g, '');
        }
        context.push(action);
    }

    return context.join('-');
}

/**
 *
 * @param category
 * @param action
 * @param label
 * @param value
 *
 * @todo Add support for catching events when GA is not ready, and then when it is ready log previously attempted events
 */
function track(category, action, label, value) {
    let data = {
        send_to: null,
        event_category: category,
        event_label: label,
        value: value,
        transport: 'beacon',
    };
    try {
        assertGa();
        for (const tracker of ga.getAll()) {
            data.send_to = tracker.get('trackingId');
            gtag('event', action, data);
        }
    } catch (exception) {
        console.error('Tried:', exception, action, data);
    }
}

function dataTrack(action, data) {
    try {
        assertGa();
        for (const tracker of ga.getAll()) {
            data.send_to = tracker.get('trackingId');
            gtag('event', action, data);
        }
    } catch (exception) {
        console.error('Tried:', exception, action, data);
    }
}

window._track = track;
window._dataTrack = dataTrack;

module.exports = {
    track,
    dataTrack,
    assertGa,
    guessContext,
};
